<template>
   <div style="width: 100%;background: #fff;">
    <div class="header">
        <div class="header-info">
            <div class="logo-div"  @click="HandleImgPage">
                <img src="../../assets/headerLogo.png" alt="" >
             
            </div>
            <div   style="display: flex;justify-content: space-between;align-items: center;">
                <div class="input-box" v-show="widthNew">
                    <el-input v-model="input" placeholder="政策解读/询专家/找服务"  @change ="selectInput()">
                        <el-select v-model="select" slot="prepend" placeholder="请选择地区">
                            <el-option label="广州" value="1"></el-option>
                            <el-option label="东莞" value="2"></el-option>
                        </el-select>
                        <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;"  @click ="selectInput()"></i>
                    </el-input>
                </div>
                <p class="welcome" v-show="loginStutas">
                    欢迎 {{ loginName == ''? phone : loginName == 'null' ? phone : loginName }}
                    <br v-show="!widthNew">进入
                    <span style="color: #4095e5;cursor: pointer;" @click="getPersonal">会员中心</span>
                    <!-- <br> -->
                    <span class="outclass" @click="handleOut">退出登陆</span>
                </p>
                <div class="user-box"  v-show="!loginStutas">
                    <p v-show="false">欢迎光临，企链工</p>
                    <el-button type="primary" class="loginButton" style="border-right: 1px solid #f2f2f2;" @click="HandleRegister">注册</el-button> 
                    <el-button class="loginButton" @click="HandleLogin">登录</el-button>  
                </div>
                
            </div>
        </div>
        <div class="header-nav">
            <ul>
                <li @click="goHome">首页</li>
                <li @click="goRecommend">推荐</li>
                <li v-for="item in listNav" :key="item.id" @click="handleArticle(item)">
                    {{ item.name }}
                </li>
                <li @click="handleFu">赋能</li>
                <!-- <li>
                    <el-dropdown>
                        <span class="el-dropdown-link">
                            商家服务<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="1">商家合作</el-dropdown-item>
                            <el-dropdown-item>我的订单</el-dropdown-item>
                            <el-dropdown-item>我的询价单</el-dropdown-item>
                            <el-dropdown-item>订单审批</el-dropdown-item>
                            <el-dropdown-item>售后服务</el-dropdown-item>
                            <el-dropdown-item>关注/收藏</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </li> -->
                <li class="dropdown_box">
                    <el-dropdown @command="getHelp" trigger="click">
                        <span class="el-dropdown-link">
                            帮助中心<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="item" v-for="item in helpList" :key="item.cate_id">{{item.cate_name}}</el-dropdown-item>
                            <!-- <el-dropdown-item>如何支付</el-dropdown-item>
                            <el-dropdown-item>查订单进度</el-dropdown-item>
                            <el-dropdown-item>如何询价</el-dropdown-item>
                            <el-dropdown-item>售后服务</el-dropdown-item>
                            <el-dropdown-item>加入我们</el-dropdown-item> -->
                        </el-dropdown-menu>
                    </el-dropdown>
                </li>
            </ul>
        </div>
    </div>
    
   </div>
</template>
<script>

export default{
    props: ['token'],
    data(){
        return{
            help1: '商家服务',
            help2: '帮助中心',
            help3: '会员中心',
            input: '',
            select: '',
            // navPosition: '',
            widthNew: false,
            cate_values: ['maintype','industry'],
            maintypeData:[],
            listarticle: [],
            channel: 'policy',
            maintype_ids: '',
            listNav: [],
            loginStutas: false,
            loginName: '',
            phone: '',
            helpList: ''
        }
    },
    watch:{
        token(newValue,oldValue){
            if(newValue != '' && newValue != oldValue){
                this.loginStutas = true
                this.loginName = localStorage.getItem('loginName')
            }
        }
    },
    methods: {  
        handleFu(){
            this.$router.push('/funeng')
        },
        handleArticle(val){
            console.log("ces");
            console.log(val);
            if(val.id == 10){ 
                this.$router.push({
                    path: '/article',
                })
                
                sessionStorage.setItem("name",'法律法规') 
                sessionStorage.setItem("channel",'law') 
                this.resetSetItem('typeId', '');
            }else if(val.id == 7){
                this.$router.push({
                    path: '/channelPolicy',
                })
                sessionStorage.setItem("name",'环保服务') 
                sessionStorage.setItem("channel",'policy') 
                this.resetSetRecomId('recommendIds', '39');
            }else if(val.id == 3){
                this.$router.push({
                    path: '/channelPolicy',
                })
                sessionStorage.setItem("name",'安全生产') 
                sessionStorage.setItem("channel",'policy') 
                this.resetSetRecomId('recommendIds','1902')
            }else if(val.id == 4){
                this.$router.push({
                    path: '/channelPolicy',
                })
                sessionStorage.setItem("name",'消防服务') 
                sessionStorage.setItem("channel",'policy') 
                this.resetSetRecomId('recommendIds','36')
            }else if(val.id == 5){
                this.$router.push({
                    path: '/channelPolicy',
                })
                sessionStorage.setItem("name",'特种设备') 
                sessionStorage.setItem("channel",'policy') 
                this.resetSetRecomId('recommendIds','37')
            }else if(val.id == 6){
                this.$router.push({
                    path: '/channelPolicy',
                })
                sessionStorage.setItem("name",'职业健康') 
                sessionStorage.setItem("channel",'policy') 
                this.resetSetRecomId('recommendIds','38')
            }else if(val.id == 9){
                this.$router.push({
                    path: '/expert',
                })
                sessionStorage.setItem("name",'在线专家') 
            }else if(val.id == 8){
                this.$router.push({
                    path: '/school'
                })
            }else if(val.id == 11){
                //供应商入驻
                this.$router.push({
                    path: '/joinList'
                })
            }else if(val.id == 2){

                // 安全培训
                this.$router.push({
                    path: '/train'
                })
            }
           
        },
        getHeaderNav(){
            this.listNav = []
            let data = {
                cate_value : 'quicknav'
            }
            this.$store.dispatch('login/listads',data)
                .then(res => {
                    if(res.ok){
                        this.listNav = res.data.items

                        
                    }
                })
        },
        goHome(){
            this.$router.push({
                path: '/'
            })
        },
        goRecommend(){
            this.$router.push({
                path: '/recommend'
            })
        },
        selectInput(){
            if(this.input != ''){
                this.$router.push({
                    path: '/search',
                    query: {
                        val: this.input
                    }
                })
            }
        },
        getPersonal(){
            this.$router.push({
                path: '/personal'
            })
            localStorage.setItem('active','1')
        },
        HandleRegister(){
            this.$router.push({
                path: '/register'
            })
        },
        HandleLogin(){
            this.$router.push({
                path: '/login'
            })
        },
        HandleImgPage(){
            this.$router.push({
                path: '/homePage'
            })
        },
        getHelp(val){
           
            if(val.items != ''){
                sessionStorage.setItem("helpMeunId",val.items[0].id)
            }else{
                sessionStorage.setItem("helpMeunId",val.cate_id)
            }
            const { href } = this.$router.resolve({
                path: '/help/orders',
            });
            
            window.open(href, '_blank');
        },
        handleOut(){
            this.$confirm('确定要退出登陆吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loginStutas = false

                this.$notify({
                    title: '提示',
                    message: '退出成功',
                    type: 'warning'
                })
                // 状态保持清除后刷新页面
                window.location.reload()
                localStorage.removeItem("token")
                this.$forceUpdate()
                this.$router.push('/homePage')
            }).catch(() => {
                    
            });
        }
        

    },  
    mounted(){
        if(localStorage.getItem('token')){
            this.loginName = localStorage.getItem('loginName')
            this.phone = localStorage.getItem('phone')
            this.loginStutas = true
            
            this.$forceUpdate()
        }else{
            this.loginStutas = false
            this.$forceUpdate()
        }
        
        

        this.getHeaderNav()
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }

        let data = {}
        this.$store.dispatch('help/listHelpByCate',data)
            .then(res => {
                this.helpList = res.data.items
            })
    }
}
</script>
<style scoped lang="scss">
*{
    margin: 0;padding: 0;
}
.header{
    width: 100%;
    margin:0 auto;
     /* */
}
.header-info{
    width: 1230px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
}
.logo-div{
    height: 80px;
    cursor: pointer;
}
.logo-div img{
    width: 220px;height: 55px;
    padding-top: 12px;
}
.logo-box{
    min-width: 60px;
}


.input-box{
    margin-right: 10px;
    max-width: 520px;
}
.input-box .el-select {
    width: 120px;
}
.user-box{
    text-align: center;
}
.avatar-box{
    margin-right: 10px;
}
.user-box .el-button{
    border-radius: 8px;
    padding: 10px 15px;
}
.user-box p{
    font-size: 18px;
}


::v-deep .el-dropdown-menu__item{
        padding: 0 20px !important;
    }
.header-nav{
    width: 100%;
    /* min-width: 1200px;
    margin: 0 auto; */
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 0px;
    background: #4095e5;
    font-size: 20px;
    height: 45px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    
    ul{
        width: 1220px;
        list-style-type: none;
        display: inline;
        cursor: pointer;
        margin: 0 auto;
        li {
            list-style-type: none;
            display: inline;
            cursor: pointer;
            margin:0 10px 0 10px;
            color: #fff;
            list-style: none;
            line-height: 20px;
            font-size: 16px;
            .el-dropdown-link{
                color: #fff;
                list-style: none;
                line-height: 20px;
                font-size: 16px;
            }
            

            
        }
        li:hover{
            color: rgba(255,255,255,0.8);
        }
    }
    
}


#router-link{
    color: #fff;
}
.welcome{
    font-size: 16px;
    margin-left: 10px;
}
.outclass{
    cursor: pointer;
    margin-left: 15px;
}
.loginButton{
    font-size: 16px;
    padding-right: 20px;
    cursor: pointer;
    margin-left: 20px;
}
.loginButton:hover{
    color: #00a8a8;
}



@media screen and (min-width: 541px) {
    
    .header-nav{
        max-width: 100%;
        min-width: 1200px;
        margin: 0 auto;
        
        
    }
  
   
}
@media screen and (max-width: 540px) {
   
    .header-info{
        width: 98%;
       
       
    }
    .logo-div{
        height: 80px;
       
    }
    .logo-div img{
        width: 180px;height: 45px;
        
    }


    .header-nav {
        width: 100%;
        ul{
            width: 90%;
            margin: 0 auto;
            padding: 0 10px 0 10px;
            overflow-x: scroll
        }
        ul::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }
        ul::-webkit-scrollbar-track {
            background-color:transparent;
            -webkit-border-radius: 2em;
            -moz-border-radius: 2em;
            border-radius:2em;
        }
        ul::-webkit-scrollbar-thumb {
            // background-color: rgb(147,147,153,0.5);
            -webkit-border-radius: 2em;
            -moz-border-radius: 2em;
            border-radius:2em;
        }
    }

   

}
</style>